/**
 * A panel whose head folds its body away.
 *
 * Built on `<details>` so the fold costs no state and no handlers: the
 * browser owns open/closed, the keyboard gets it for free (the head is a
 * `<summary>`, focusable and toggled by Space or Enter), and find-in-page
 * still reaches a folded body in browsers that auto-expand on match.
 *
 * Open by default. Folding is for the operator who wants the Send composer
 * next to the KYC case without a screen of holdings between them, not a way
 * to hide a section; a fresh page shows everything.
 *
 * `aside` is the head's right-hand slot (a timestamp, a status, a link). A
 * link there still navigates on click; the toggle that also fires is moot
 * once the page changes.
 */
export function Section({
  title,
  aside,
  children,
  className,
}: {
  title: string;
  aside?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <details className={className ? `panel ${className}` : "panel"} open>
      <summary className="panel-head section-head">
        <span className="section-title">
          <svg
            className="section-chevron"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
          >
            <path d="m9 6 6 6-6 6" />
          </svg>
          <h2>{title}</h2>
        </span>
        {aside}
      </summary>
      {children}
    </details>
  );
}
